<template>
    <div class="mainwrap">
        <div class="tune-widget-mainbar">
            <div class="tune-widget-mainbar-l">
                <img :src="img1" class="header-image" alt="start image">
            </div>
            <div class="tune-widget-mainbar-m">{{ $t("payment") }}</div>
            <div class="tune-widget-mainbar-r"> &nbsp;</div>
        </div>



        <div class="shop-results" id="payment_container">
            
            <div v-if="orderid==0"  class="center-widget">
 
                <div class="payment-redrirect" >{{ $t("payment_pre_redirection") }}</div>
     
    
                    <div class="generic-form-row" >
                        <div class="form-button-wrapper-50" style="float:left;">
                       
                        </div>
                        <div class="form-button-wrapper-50" style="float:left;padding-left:20px;">
                       
                        </div>
                    </div>

                    <div class="generic-form-row">
                        <div class="two-button-left-c">
                            <div class="tune-action-button" @click="this.$router.push('shop')">{{ $t("go_back") }}</div>
                        </div>
                        <div class="two-button-right-c">
                            <div class="tune-action-button" @click="handlePayment()">{{ $t("goto_payment") }}</div>                            
                        </div>
                    </div> 


                
            </div>

            <div v-if="orderid > 0" class="center-widget">

                <div v-if="ispaid == 1" >

                    <div v-if="postpayment">
                          <div class="finish-payment-title"></div>
                        <div class="finish-payment-checkmark"><img :src=greenCheckmark ></div>
                        <div class="finish-payment-title">{{ $t("payment_success_title")}}</div>
                        <div class="finish-payment-body">{{ $t("payment_success_body")}}</div>
                        <div class="generic-form-row" style="height:6px;"></div>
                        <div class="generic-form-row" >
                            <div class="two-button-left-c">
                                <div class="tune-action-button" style="width:155px;display:inline-block;" @click="this.$router.push('/')">{{ $t("back_to_home") }}</div>
                            </div>
                            <div class="two-button-right-c">
                                <div class="tune-action-button" style="width:155px;display:inline-block;" @click="openLinkBlank('https://rica.nl/contact/')">{{ $t("contact_us") }}</div>                            
                            </div>
                        </div> 
                         <div class="generic-form-row" style="height:6px;"></div>
                        <!-- Social + weblinks -->
                            <div class="" style="text-align:center;">
                            <div class="link-button-wrapper" ><img :src=facebookIcon class="link-icon-img" @click="openLinkBlank('https://www.facebook.com/ricanl/')"></div>
                            <div class="link-button-wrapper" ><img :src=instagramIcon class="link-icon-img" @click="openLinkBlank('https://www.instagram.com/rica_engineering/')"></div>
                            <div class="link-button-wrapper" ><img :src=youtubeIcon class="link-icon-img" @click="openLinkBlank('https://www.youtube.com/user/chiptuningnl')"></div>
                            <div class="link-button-wrapper" ><img :src=websiteIcon class="link-icon-img" @click="openLinkBlank('https://rica.nl/')"></div>
                        </div> 

                    </div>
                    <div v-else>
                        Betaling voor deze order is ontvangen 
                        <div class="payment-redrirect">{{ $t("payment_success_body")}}</div>
                        <div class="" style="text-align:center;">
                            <div v-if="ispaid != 1" class="tune-action-button" style="width:200px;display:inline-block;" @click="this.$router.push('/checkout')">{{ $t("go_back") }}</div>
                            <div v-if="ispaid == 1" class="tune-action-button" style="width:200px;display:inline-block;" @click="this.$router.push('/')">{{ $t("go_back") }}</div>
                        </div>       

                    </div>
                    
                </div>
                <div v-else >
                    <div  v-if="ispaid == 0"  class="generic-form-row" style="text-align:center;">
                        <div v-if="expired == 0">
                            <div class="payment-redrirect">{{ $t("order_not_processed")}}</div>

                            <div class="generic-form-row">
                                <div class="two-button-left-c">
                                    <div v-if="ispaid == 0" class="tune-action-button" style="width:200px;display:inline-block;" @click="this.$router.push('/checkout')">{{ $t("go_back") }}</div>
                                </div>
                                <div class="two-button-right-c">
                                    <div v-if="ispaid == 0" class="tune-action-button" style="width:200px;display:inline-block;" @click="handlePayment()">{{ $t("goto_payment") }}</div>                    
                                </div>
                            </div> 
                        
                        </div> 

                        <div v-if="expired == 1">
                            <div class="payment-redrirect">{{ $t("order_failed")}}</div>
                            <div class="generic-form-row">
                                <div class="two-button-left-c">
                                    <div v-if="ispaid == 0" class="tune-action-button" style="width:200px;display:inline-block;" @click="this.$router.push('/checkout')">{{ $t("go_back") }}</div>
                                </div>
                                <div class="two-button-right-c">
                                    <div v-if="ispaid == 0" class="tune-action-button" style="width:200px;display:inline-block;" @click="handlePayment()">{{ $t("goto_payment") }}</div>                    
                                </div>
                            </div> 
                        </div> 
                    </div>
                </div>

          

            </div>
              
        </div>


    </div>
</template>

<script>


function getParentOrigin() {
  const locationAreDisctint = (window.location !== window.parent.location);
  const parentOrigin = ((locationAreDisctint ? document.referrer : document.location) || "").toString();

  if (parentOrigin) {
    return new URL(parentOrigin).origin;
  }

  const currentLocation = document.location;

  if (currentLocation.ancestorOrigins && currentLocation.ancestorOrigins.length) {
    return currentLocation.ancestorOrigins[0];
  }

  return "";
}

import axios from 'axios'
const methods= {
    scrollToTop() {
        window.scrollTo(0,0);
        if(window.parentIFrame) {
            window.parentIFrame.scrollTo(0,0);
        }
    },
    openLinkBlank(url) {
        window.open(url, "_blank");
    },
    handlePayment() {
          var par = this;
        // this.hasResults = false;
        console.log("origin: " + getParentOrigin());
        var callback1 = getParentOrigin() + "/payment/?postpayment=1&orderid=";

        var postvars = new URLSearchParams();
        postvars.append('ep', 'payment');
        postvars.append('order', '[' + JSON.stringify(this.curOrder) + ']');
        postvars.append('total', this.curOrder.cart_total);
        
        
        var host = window.location.protocol + "//" + window.location.host;
        // postvars.append('callback_url', host+ '/payment?orderid=');
        postvars.append('callback_url', callback1);

        // console.log("handlePayment HOST :" + host);
        // console.log("handlePayment ORDER :" + this.apiHost);
        // console.log("handlePayment this.urlParams:" + this.apiHost);
        // post to gateway

        console.log("handlePayment: postvars: " + postvars);
        // return false;
        axios.post(this.apiHost, postvars)
        .then(function(response) {
            var theResponse = "";
            console.log(">> Payment response :" + JSON.stringify(response.data));
            console.log(">> Payment orderid :" + response.data.orderid);
            console.log(">> Payment callback_url :" + response.data.callback_url);
            // document.getElementById("payment_container").innerHTML = response.data.callback_url;
            // store the db order id in local order
            theResponse = response.data.msg; 
            console.log("theResponse: " + JSON.stringify(response.data)); 
            // return false;

            if(response.data.callback_url != "") {
                if(response.data.status == "expired") {
                    console.log("Payment expired, removing order :" + JSON.stringify(response.data));
                    // par.$store.commit("cancelOrder");
                    par.isExpired = 1;
                } else if(response.data.status ==  "cancelled") {                  
                    console.log("Payment cancelled, retry :" + JSON.stringify(response.data));
                    // window.location.href = response.data.callback_url;                   
                } else  if(response.data.status == "paid") {
                    console.log("Payment paid, removing order :" + JSON.stringify(response.data));
                    theResponse = response.data.msg; 
                    par.$store.commit("cancelOrder");
                    par.ispaid = 1;
                    //  window.parent.location.href = response.callback_url;
                } else {
                    if(response.data.orderid != undefined) {
                        var nd = {};
                        nd["orderid"] = response.data.orderid; 
                        par.$store.commit("updateOrderDetails", nd);
                    }
                    window.parent.location.href = response.data.callback_url;
                }
            }   
        })
        .catch(function (error) {
            console.log("Payment failed :" + error);
            console.log(error);
        })
    },
     checkPayment(orderid) {
          var par = this;
        // this.hasResults = false;
        var postvars = new URLSearchParams();
        postvars.append('ep', 'checkpayment');
        // postvars.append('clientip', this.$store.state.clientIP);
        postvars.append('orderid', orderid);
        postvars.append('total', this.curOrder.cart_total);
        console.log("checkPayment : orderid=" + orderid + "| cart_total=" + this.curOrder.cart_total);
        
        var host = window.location.protocol + "//" + window.location.host;
        postvars.append('callback_url', host+ '/payment?orderid=');

        // console.log("checkPayment HOST :" + host);
        // // console.log("checkPayment ORDER :" + JSON.stringify(this.curOrder));
        // console.log("checkPayment ORDER RAW:" + this.$store.state.curOrder.cart_total);
        // console.log("this.urlParams:" + this.apiHost);

            // post to gateway
            axios.post(this.apiHost, postvars)
            .then(function(response) {
                var theResponse = "";
                console.log("checkPayment response :" + JSON.stringify(response.data));
                    var isPaid = response.data.data.ispaid;
                    var isExpired = response.data.data.expired;
                    console.log("\n checkPayment isExpired :" + isExpired);
                    if(isPaid == "1" ) {
                        //            console.log("\n paid or expired, remove the order :" + isPaid);
                        par.ispaid = 1;
                       // par.$store.commit("cancelOrder");
                    } else if(isExpired == "1") {
                        par.ispaid = 0;
                        par.expired = 1;
                     //   par.$store.commit("cancelOrder");
                    } else {
                        
                        par.handlePayment();
                    }
            })
            .catch(function (error) {
                console.log("checkPayment failed :" + error);
                console.log(error);
            })
  
    }

}
export default {
    data() {
        var apiHost =  process.env.VUE_APP_RICA_API_HOST;
        var orderid = 0;
        var clientIP = "";
        this.$i18n.locale =  this.$store.state.curLanguage
        var postpayment = false;
        if(this.$store.state.curOrder.orderid) {
            orderid = this.$store.state.curOrder.orderid;
        }
        if(this.$route.query.orderid) {
            orderid = this.$route.query.orderid
        }
        if(this.$route.query.postpayment) {
            postpayment = true;
        }
        return {
            img1:require('./../assets/header-logo.png'),
            greenCheckmark:require('./../assets/green-checkmark.png'),
            facebookIcon:require('./../assets/facebook-icon.png'),
            instagramIcon:require('./../assets/instagram-icon.png'),
            youtubeIcon:require('./../assets/youtube-icon.png'),
            websiteIcon:require('./../assets/website-icon.png'),
            apiHost,
            ispaid:false,
            expired:false,
            orderid,
            postpayment,
            clientIP
        }
    },
    methods: methods,
    computed: {
        shoppingCart: function () {
            return this.$store.state.shoppingCart;
        },
        curOrder: function () {
            return this.$store.state.curOrder;
        },
    },
    mounted() {
//                 fetch('https://api.ipify.org?format=json')
// .then(x => x.json())
// .then(({ ip }) => {
//     this.clientIP = ip;
// });
this.scrollToTop();
        this.checkPayment(this.orderid);
        // this.handlePayment();

        

    }
}
</script>

<style>

</style>